import React from 'react';
/** Components Import */
import Section from '../../Components/Section';
import Card from '../../Components/Card_wrap';
import AuthGroupButton from '../../Components/Button_Auth_Group';
import BasicModal from '../../Components/Modal_Basic';
import CkeckingForm from '../../Components/CkeckingForm';
import BasicButton from '../../Components/Button_Basic';
import Accordion from '../../Components/AccordionGroup';
import CardH3 from '../../Components/Card_H3';
/** Ag-grid Import */
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { AgGridReact } from 'ag-grid-react';
import GridFunctions from '../../Services/agGrid/ag-Grid-functions';
import { useSelector, useDispatch } from 'react-redux';

function BM10120(props) {
    const gridRef = React.useRef();
    //그리드 컬럼
    const columnDefs = [
        {
            field: 'title',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_Title' && f.lanType === 'COL')[0].lanName
                    : '', //제목
            minWidth: 150,
            headerCheckboxSelection: true,
            checkboxSelection: true,
            editable: false,
        },
        {
            field: 'value',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_Remark' && f.lanType === 'COL')[0].lanName
                    : '', //비고
            editable: false,
        },
    ];
    const [modalToggle, setModalToggle] = React.useState(false);
    const onCellClicked = (e) => {
        const selected = e.data;
        props.setInputs({
            ...props.inputs,
            //품목정보
            title: selected.title,
            remark: selected.value,
        });

        props.setSelectedRowData([
            {
                ...props.selectedRowData,
                plantCd: selected.plantCd,
                itemCd: selected.itemCd,
            },
        ]);
    };
    React.useEffect(() => {
        document.title = '공지사항';
        const element = document.getElementById('topbar');
        element.innerHTML =
            '<h1>' +
            "<span class='bullet'>" +
            '</span>' +
            "<strong class='depth-1'>" +
            '기초관리' +
            '	</strong>' +
            "<span class='divider' >" +
            '</span>' +
            "<strong'>공지사항</strong>" +
            '</h1>';
        let a = props.rowData;
    }, []);

    return (
        <div>
            <Section />
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-evenly',
                    alignItems: 'center',
                }}
            >
                <div style={{ width: '60%' }}>
                    <Card
                        wrapStyle={{
                            display: 'flex',
                            justifyContent: 'flex-end',
                        }}
                    >
                        {/* 그리드 버튼 */}
                        <AuthGroupButton
                            pageName="BM10120"
                            target="G01"
                            selectFunc={() => {
                                props.Init();
                            }}
                            refreshNone="none"
                            addFunc={() => {
                                props.setInputs({
                                    ...props.inputs,
                                    title: '',
                                    remark: '',
                                });
                            }}
                            saveFunc={() => props.SaveConfirm()}
                            deleteFunc={() => props.DeleteConfirm()}
                        />
                    </Card>
                    <Section />
                    <div className="ag-theme-alpine no-scroll" style={{ width: '100%', height: '770px' }}>
                        {/* 그리드 */}
                        <AgGridReact
                            ref={gridRef}
                            animateRows={true}
                            columnDefs={columnDefs}
                            defaultColDef={{
                                flex: 1,
                                minWidth: 100,
                                editable: true,
                                resizable: true,
                                sortable: true,
                                filter: true,
                                floatingFilter: true,
                            }}
                            rowData={props.rowData}
                            rowSelection="multiple"
                            onCellClicked={onCellClicked}
                            onSelectionChanged={() =>
                                GridFunctions.onSelectionChanged(gridRef, props.setSelectedRowData)
                            }
                            onCellValueChanged={(e) => {
                                GridFunctions.onCellValueChanged(e, gridRef, props.setChangedRowData);
                            }}
                            getRowStyle={(e) => GridFunctions.getRowStyle(e)}
                        />
                    </div>
                </div>
                <div style={{ width: '39%' }}>
                    <Card
                        wrapStyle={{
                            display: 'flex',
                            justifyContent: 'flex-end',
                        }}
                    >
                        {/* 그리드 버튼 */}
                        <AuthGroupButton
                            pageName="BM10120"
                            target="G02"
                            selectFunc={() => {
                                props.Init();
                            }}
                            refreshFunc={() => {
                                props.setInputs({
                                    ...props.inputs,
                                    title: '',
                                    remark: '',
                                });
                            }}
                            addFunc={() =>
                                props.setInputs({
                                    ...props.inputs,
                                    title: '',
                                    remark: '',
                                })
                            }
                            saveFunc={() => props.SaveConfirm()}
                            deleteFunc={() => props.DeleteConfirm()}
                        />
                    </Card>
                    <div className="ag-theme-alpine no-scroll" style={{ width: '100%', height: '770px' }}>
                        <textarea
                            style={{
                                height: '50px',
                                width: '100%',
                                // margin: "0px 5px",
                                // padding: "5px",
                                fontSize: '16px',
                                border: '1px solid #e4e4e4',
                            }}
                            value={props.inputs.title}
                            onChange={(e) => {
                                props.setInputs({
                                    ...props.inputs,
                                    title: e.target.value,
                                });
                            }}
                            placeholder={'제목'}
                        />
                        <textarea
                            style={{
                                height: '670px',
                                width: '100%',
                                // margin: "0px 5px",
                                // padding: "5px",
                                fontSize: '16px',
                                border: '1px solid #e4e4e4',
                            }}
                            value={props.inputs.remark}
                            onChange={(e) => {
                                props.setInputs({
                                    ...props.inputs,
                                    remark: e.target.value,
                                });
                            }}
                            placeholder={'공지사항'}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
    // return (
    //   <div>
    //     <Card
    //       wrapStyle={{
    //         height: "10vh",
    //         display: "flex",
    //         flexDirection: "column",
    //         justifyContent: "center",
    //         alignItems: "center",
    //       }}
    //     >
    //       <CardH3 name={"공지사항"} />
    //     </Card>
    //     <Card style={{ height: "660px", marginTop: "0px", overflow: "scroll" }}>
    //       <Accordion datas={props.boardList} />
    //     </Card>

    //     <div>
    //       <BasicButton name="저장" onClick={(e) => props.SaveConfirm()} />
    //     </div>
    //   </div>
    // );
}

export default BM10120;
